import { Grid, withWidth, Menu, MenuItem} from "@material-ui/core";
import React from "react";
import {DeployButton} from "../../../../styles";
//import MxraasLogo from "../../assert/images/mxraas-logo.svg";
//import MxraasTempLogo from "../../assert/images/mxrass-temp-logo.svg";
import { Spinner, SpinnerSize, Text } from 'office-ui-fabric-react';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Topbarbg from "../../../../assert/images/topbar-bg.webp";
import Logo from "../../../../assert/images/landingPage/ManageXLogo.png";
import Button from "../../../../assert/images/button.png";
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles } from "@material-ui/core/styles";
import { Redirect } from 'react-router-dom';

export const useStyles = makeStyles(() => ({
    menu: {
        "& .MuiPaper-root": {
            backgroundColor: "#273041"
        }
    }
}));

function Headline(props) {
    const MENU_ITEMS = {
        HOME: "home",
        BENEFITS: "benefits",
        ELIMINATE: "eliminate",
        OFFER: "offer",
        RESOURCES: "resources"
    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const classes = useStyles();
    const [redirect, setRedirect] = React.useState(false);

    if (redirect) {
        props.setPathUrl('/');
        window.location.reload(false);
        return <Redirect to='/' />
    }

    
    return (
    <React.Fragment>

            <AppBar elevation={3} style={{
                backgroundColor: "#273041",
                backgroundImage: `url(${Topbarbg})`, backgroundPosition: 'center',
                backgroundSize: 'cover',
            }}>
                <Toolbar>
                    <Grid container
                        direction="row"
                        justifyContent="flex-start"
                        //alignItems="center"
                        style={{ padding: "7px 0px 0px 0px" }}                        
                    >
                        {
                            props.width === 'xs' || props.width === 'sm' ?
                                <Grid item xs={1}>

                                    <MenuIcon onClick={ handleClick} />
                                    <Menu
                                        id="basic-menu"
                                        className={classes.menu}
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        MenuListProps={{
                                            'aria-labelledby': 'basic-button',
                                        }}
                                        style={{backgrounDColor:"black"}}
                                    >
                                        {
                                            props.pathUrl === "/" ?
                                                <MenuItem onClick={() => { handleClose(); props.handleMenuClick(MENU_ITEMS.HOME); }}><Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.HOME ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} >Home</Text></MenuItem> :
                                                props.pathUrl === "/hpc" ?
                                                    <>
                                                        <MenuItem onClick={() => { handleClose(); props.handleMenuClick(MENU_ITEMS.HOME); }}><Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.HOME ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} >Home</Text></MenuItem>
                                                        <MenuItem onClick={() => { handleClose(); props.handleMenuClick(MENU_ITEMS.BENEFITS); }}><Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.BENEFITS ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} >Benefits</Text></MenuItem>
                                                        <MenuItem onClick={() => { handleClose(); props.handleMenuClick(MENU_ITEMS.OFFER); }}><Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.OFFER ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} >Offering</Text></MenuItem>
                                                        <MenuItem onClick={() => { handleClose(); props.handleMenuClick(MENU_ITEMS.RESOURCES); }}> <Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.RESOURCES ? "#14E2C5" : "#fff", paddingRight: 30, fontWeight: 500, cursor: "pointer" }}>Resources</Text></MenuItem>
                                                    </> :
                                                    <>
                                                        <MenuItem onClick={() => { handleClose(); props.handleMenuClick(MENU_ITEMS.HOME); }}><Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.HOME ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} >Home</Text></MenuItem>
                                                        <MenuItem onClick={() => { handleClose(); props.handleMenuClick(MENU_ITEMS.BENEFITS); }}><Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.BENEFITS ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} >Solutions</Text></MenuItem>
                                                        <MenuItem onClick={() => { handleClose(); props.handleMenuClick(MENU_ITEMS.RESOURCES); }}> <Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.RESOURCES ? "#14E2C5" : "#fff", paddingRight: 30, fontWeight: 500, cursor: "pointer" }}>Resources</Text></MenuItem>
                                                    </>
                                        }
                                        
                                    </Menu>
                                </Grid> :<></>
                        }
                        <Grid item xs={8} sm={8} md={6} style={{ textAlign: props.width === "xs" || props.width === 'sm' ? "center" : 'left' }} onClick={() => { setRedirect(true); }}>
                            <img src={Logo} alt={"LOGO"} className={props.classes.headingLogo} style={{cursor:"pointer"}}  />
                        </Grid>
                        {
                            props.width === 'xs' || props.width === 'sm' ?
                                <Grid item xs={3} sm={3} style={{ textAlign:"right"}}>
                                    <DeployButton disabled={props.auth.state === props.AuthState.LOGIN_REQUEST || props.auth.state === props.AuthState.SET_TOKEN}
                                        style={{
                                            backgroundImage: `url(${Button})`, backgroundPosition: 'center',
                                            backgroundSize: 'cover'
                                        }}
                                        onClick={() => { props.setShowRequestTrialMessage(false); props.onSignIn(); }}
                                    >
                                        {props.auth.state === props.AuthState.LOGIN_REQUEST || props.auth.state === props.AuthState.SET_TOKEN ? <Spinner styles={{ root: { marginBottom: '0px' } }} size={SpinnerSize.small} /> : <Text style={{ fontSize: 14 }}> Sign in</Text>}
                                    </DeployButton>
                                </Grid>
                                :

                                <Grid item xs={12} sm={7} md={6} style={{ textAlign: props.width === "xs" ? "center" : 'right', }}>
                                    {
                                        props.pathUrl === "/" || props.pathUrl === "" ?
                                            <>
                                                <Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.HOME ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} onClick={() => { props.handleMenuClick(MENU_ITEMS.HOME); }}>Home</Text>
                                            </> :
                                            props.pathUrl === "/hpc" ?
                                                <>
                                                    <Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.HOME ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} onClick={() => { props.handleMenuClick(MENU_ITEMS.HOME); }}>Home</Text>
                                                    <Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.BENEFITS ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} onClick={() => { props.handleMenuClick(MENU_ITEMS.BENEFITS); }}>Benefits</Text>
                                                    {/*<Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.ELIMINATE ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} onClick={() => { props.handleMenuClick(MENU_ITEMS.ELIMINATE); }}>Eliminate</Text>*/}
                                                    <Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.OFFER ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} onClick={() => { props.handleMenuClick(MENU_ITEMS.OFFER); }}>Offering</Text>
                                                    <Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.RESOURCES ? "#14E2C5" : "#fff", paddingRight: 30, fontWeight: 500, cursor: "pointer" }} onClick={() => { props.handleMenuClick(MENU_ITEMS.RESOURCES); }}>Resources</Text>
                                                </> :
                                                <>
                                                    <Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.HOME ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} onClick={() => { props.handleMenuClick(MENU_ITEMS.HOME); }}>Home</Text>
                                                    <Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.BENEFITS ? "#14E2C5" : "#fff", paddingRight: 20, fontWeight: 500, cursor: "pointer" }} onClick={() => { props.handleMenuClick(MENU_ITEMS.BENEFITS); }}>Solutions</Text>
                                                    <Text style={{ fontSize: 14, color: props.selectTab === MENU_ITEMS.RESOURCES ? "#14E2C5" : "#fff", paddingRight: 30, fontWeight: 500, cursor: "pointer" }} onClick={() => { props.handleMenuClick(MENU_ITEMS.RESOURCES); }}>Resources</Text>
                                                </>
                                    }
                                    <DeployButton disabled={props.auth.state === props.AuthState.LOGIN_REQUEST || props.auth.state === props.AuthState.SET_TOKEN}
                                        style={{
                                            backgroundImage: `url(${Button})`, backgroundPosition: 'center',
                                            backgroundSize: 'cover'
                                        }}
                                        onClick={() => {
                                            props.setShowRequestTrialMessage(false);
                                            props.setSignInClick(true);
                                           // props.onSignIn();
                                        }}
                                    >
                                        {props.auth.state === props.AuthState.LOGIN_REQUEST || props.auth.state === props.AuthState.SET_TOKEN ? <Spinner styles={{ root: { marginBottom: '0px' } }} size={SpinnerSize.small} /> : <Text style={{ fontSize: 14 }}> Sign in</Text>}
                                    </DeployButton>
                                </Grid>
                        }
                    </Grid>
                </Toolbar>
            </AppBar>
            
      
    </React.Fragment>
    );
}

export default withWidth()(Headline);